module.exports = __webpack_public_path__ + "static/img/advantage1.d5dcc01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advantage1.png
// module id = y43b
// module chunks = 8